import { apiGet, apiPost, apiPut, apiDelete } from '@/services/api/apiClient';

export interface Supplier {
  _id: string;
  companyName: string;
  companyId?: string | null;
  gst: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  pinCode: string;
  email: string;
  mobile: string;
  isActive: boolean;
  isDeleted: boolean;
  remarks?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SupplierFormData {
  companyName: string;
  companyId?: string;
  gst: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  pinCode: string;
  email: string;
  mobile: string;
  isActive: boolean;
  remarks?: string;
}

export interface SupplierListParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
}

export interface SupplierListResponse {
  success: boolean;
  message: string;
  data: {
    docs: Supplier[];
    totalDocs: number;
    limit: number;
    totalPages: number;
    page: number;
    pagingCounter: number;
    hasPrevPage: boolean;
    hasNextPage: boolean;
    prevPage: number | null;
    nextPage: number | null;
  };
}

export interface SupplierResponse {
  success: boolean;
  message: string;
  data: Supplier;
}

class SupplierService {
  private baseUrl = '/suppliers';

  async getSuppliers(params: SupplierListParams = {}): Promise<SupplierListResponse> {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive.toString());

    const url = `${this.baseUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return apiGet<SupplierListResponse>(url);
  }

  async createSupplier(data: SupplierFormData): Promise<SupplierResponse> {
    return apiPost<SupplierResponse>(this.baseUrl, data);
  }

  async updateSupplier(id: string, data: SupplierFormData): Promise<SupplierResponse> {
    return apiPut<SupplierResponse>(`${this.baseUrl}/${id}`, data);
  }

  async deleteSupplier(id: string): Promise<{ success: boolean; message: string }> {
    return apiDelete<{ success: boolean; message: string }>(`${this.baseUrl}/${id}`);
  }

  async getSupplierById(id: string): Promise<SupplierResponse> {
    return apiGet<SupplierResponse>(`${this.baseUrl}/${id}`);
  }
}

export const supplierService = new SupplierService();